export default __webpack_public_path__ + "static/media/PodderLogo.8008febd.png";